// extracted by mini-css-extract-plugin
export default {"label":"ToggleCheckboxInfo_label--dJK"};